/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_No as No,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_h as h,
  rec_ra as ra,
} from "../../runtime/index.jsx";
export function Modal(e) {
  let t = (0, ReactCompiler.c)(21),
    { titulo: n, onClose: r, children: i, ancho: a } = e,
    o = a === void 0 ? `max-w-lg` : a,
    s = (0, React.useRef)(null),
    c = (0, React.useRef)(null),
    [l, u] = (0, React.useState)(!1),
    f;
  t[0] === r
    ? (f = t[1])
    : ((f = () => {
        let e;
        try {
          e = window.matchMedia(`(prefers-reduced-motion: reduce)`).matches;
        } catch {
          e = !1;
        }
        if (e) {
          r();
          return;
        }
        (u(!0), setTimeout(r, 160));
      }),
      (t[0] = r),
      (t[1] = f));
  let p = f,
    m,
    _;
  (t[2] === p
    ? ((m = t[3]), (_ = t[4]))
    : ((m = () => {
        c.current = document.activeElement;
        let e = document.body.style.overflow;
        ((document.body.style.overflow = `hidden`),
          s.current?.focus?.({
            preventScroll: !0,
          }));
        let t = (e) => {
          if (e.key === `Escape`) {
            p();
            return;
          }
          if (e.key !== `Tab` || !s.current) return;
          let t = s.current.querySelectorAll(
            `a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])`,
          );
          if (t.length === 0) return;
          let n = t[0],
            r = t[t.length - 1];
          !e.shiftKey && document.activeElement === r
            ? (e.preventDefault(), n.focus())
            : e.shiftKey &&
              document.activeElement === n &&
              (e.preventDefault(), r.focus());
        };
        return (
          window.addEventListener(`keydown`, t),
          () => {
            (window.removeEventListener(`keydown`, t),
              (document.body.style.overflow = e),
              c.current?.focus?.({
                preventScroll: !0,
              }));
          }
        );
      }),
      (_ = [p]),
      (t[2] = p),
      (t[3] = m),
      (t[4] = _)),
    (0, React.useEffect)(m, _));
  let v = `fixed inset-0 z-50 flex items-end justify-center bg-black/40 sm:items-center sm:p-4 ${l ? `animar-salida` : `animar-fundido`}`,
    y = `${l ? `modal-saliendo` : `animar-entrada`} w-full ${o} max-h-[92dvh] overflow-y-auto rounded-t-2xl bg-(--bg) p-4 shadow-[var(--sombra-flotante)] sm:max-h-[90vh] sm:rounded-2xl sm:p-6`,
    b;
  t[5] === n
    ? (b = t[6])
    : ((b = (
        <h2
          className={`text-lg font-medium text-(--text-h) sm:text-xl`}
          children={n}
        />
      )),
      (t[5] = n),
      (t[6] = b));
  let x;
  t[7] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((x = (0, JSXRuntime.jsx)(ra, {
        className: `h-5 w-5`,
      })),
      (t[7] = x))
    : (x = t[7]);
  let S;
  t[8] === p
    ? (S = t[9])
    : ((S = (
        <button
          type={`button`}
          onClick={p}
          aria-label={`Cerrar`}
          className={`-m-1 rounded-xl p-2 text-(--text) transition duration-150 ease-(--curva) hover:bg-(--accent-bg) active:scale-[0.94] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--accent-border)`}
          children={x}
        />
      )),
      (t[8] = p),
      (t[9] = S));
  let C;
  t[10] !== b || t[11] !== S
    ? ((C = (
        <div
          className={`mb-4 flex items-start justify-between gap-4`}
          children={[b, S]}
        />
      )),
      (t[10] = b),
      (t[11] = S),
      (t[12] = C))
    : (C = t[12]);
  let w;
  t[13] !== i || t[14] !== C || t[15] !== y
    ? ((w = (
        <div
          ref={s}
          role={`dialog`}
          aria-modal={`true`}
          tabIndex={-1}
          className={y}
          onClick={No}
          children={[C, i]}
        />
      )),
      (t[13] = i),
      (t[14] = C),
      (t[15] = y),
      (t[16] = w))
    : (w = t[16]);
  let T;
  return (
    t[17] !== p || t[18] !== w || t[19] !== v
      ? ((T = (0, h.createPortal)(
          <div className={v} onClick={p} children={w} />,
          document.body,
        )),
        (t[17] = p),
        (t[18] = w),
        (t[19] = v),
        (t[20] = T))
      : (T = t[20]),
    T
  );
}
